import Vue from 'vue';
import options from './index.vue';
import defaultItemOpts from './selectbarItem.vue';
import storeItemOpts from './selectbarStoreItem.vue';

Vue.component('tg-selectbar', options);
Vue.component('tg-selectbar-default-item', defaultItemOpts);
Vue.component('tg-selectbar-store-item', storeItemOpts);